import React, { useEffect, useState } from 'react';
import logo from '../assets/Asset 1.svg';

export default function Preloader() {
    const [isVisible] = useState(true);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        // Simulate progress for the custom loading bar
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 2;
            });
        }, 30);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={`fixed inset-0 z-[9999] bg-black flex flex-col items-center justify-center transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none translate-y-[-100%]'}`}>

            {/* Background Grain/Noise Overlay */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")` }}></div>

            <div className="relative flex flex-col items-center">
                {/* Central Logo with high-impact animation */}
                <div className="w-32 h-32 md:w-48 md:h-48 relative group animate-float">
                    {/* Pulsing Glow behind logo */}
                    <div className="absolute inset-0 bg-green-500/20 rounded-full blur-3xl animate-pulse"></div>

                    <img
                        src={logo}
                        alt="Logo"
                        className="w-full h-full object-contain relative z-10 drop-shadow-[0_0_15px_rgba(71,232,2,0.3)]"
                    />
                </div>

                {/* Text Content */}
                <div className="mt-12 text-center overflow-hidden">
                    <h2 className="text-white font-black text-2xl md:text-4xl tracking-[0.3em] uppercase animate-fade-in-up">
                        Moris <span className="text-green-500">Owen</span>
                    </h2>
                    <p className="text-gray-500 font-bold tracking-[0.5em] uppercase text-[10px] mt-4 opacity-50">
                        Designing the Future
                    </p>
                </div>

                {/* Progress Bar Container */}
                <div className="mt-16 w-48 md:w-64 h-[2px] bg-white/10 rounded-full overflow-hidden relative">
                    <div
                        className="absolute inset-y-0 left-0 bg-green-500 shadow-[0_0_10px_#47e802] transition-all duration-300 ease-out"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>

                <div className="mt-4 text-[10px] font-black text-gray-600 tracking-widest uppercase">
                    {progress}%
                </div>
            </div>

            {/* Bottom Credit */}
            <div className="absolute bottom-12 text-[10px] font-black text-gray-700 tracking-[1em] uppercase">
                © 2026
            </div>
        </div>
    );
}
